<template>
  <instagram />
</template>

<script>
import Vue from 'vue'
import instagram from '@/components/InstagramHome.vue'

export default {
  name: 'InstagramHome',
  components: {
    instagram
  }
}
</script>
